import React from "react";
import ToolTip from "components/ToolTip";

import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { selectLocale } from "store/app/selectors";

import CustomFormatNumber from "components/CustomFormatNumber";

const PercentValueCom = ({ percentValue, right }) => (
    <>
        {typeof percentValue !== "undefined" ? (
            <div className="d-flex align-center">
                <span className={`text-14 fw-600 mr-2 ${Math.sign(percentValue) === -1 ? "danger-red-color" : "primary-color"}`}>
                    {`${Math.sign(percentValue) === 1 ? "+" : ""}`}
                    <CustomFormatNumber value={percentValue} symbol="%" />
                </span>
                {right}
            </div>
        ) : (
            right
        )}
    </>
);

const ShareValuation = ({
    title,
    finalValuation,
    locale,
    finalValuationSymbol,
    valuations,
    className,
    lClassname = "",
    percentValue,
    finalValuationSymbolClassName,
}) => (
    <section className={`item-block shadow border-radius ${className}`}>
        {title && (
            <div className="item-block__header item-block__part">
                <div className="flex justify-between row align-center">
                    <label className={lClassname}>{title}</label>
                    <PercentValueCom
                        percentValue={percentValue}
                        locale={locale}
                        right={
                            <span className="text-display">
                                {typeof finalValuation !== "undefined" ? (
                                    typeof finalValuationSymbol !== "undefined" ? (
                                        <>
                                            {finalValuation}{" "}
                                            <span className={finalValuationSymbolClassName}>{finalValuationSymbol}</span>
                                        </>
                                    ) : (
                                        <CustomFormatNumber value={finalValuation} />
                                    )
                                ) : (
                                    ""
                                )}
                            </span>
                        }
                    />
                    <ToolTip id="title" />
                </div>
            </div>
        )}
        <div className="item-block__part">
            {valuations.map(
                ({ className, size, title, value, symbol, percentValue, fixed = 2, text = false, lClassname }, index) => (
                    <div key={title + index} className={`flex justify-between row align-center ${className ? className : ""}`}>
                        <label className={lClassname}>{title}</label>
                        <PercentValueCom
                            key={title + index + "new"}
                            percentValue={percentValue}
                            locale={locale}
                            right={
                                <span className={`${size ? size : "text-16 fw-600"}`}>
                                    {text ? value : <CustomFormatNumber value={value} symbol={symbol} fixed={fixed} />}
                                </span>
                            }
                        />
                        <ToolTip id="valuations" />
                    </div>
                ),
            )}
        </div>
    </section>
);

const mapStateToProps = createStructuredSelector({
    locale: selectLocale,
});

export default connect(mapStateToProps)(ShareValuation);
